import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { Area } from '../../../../core/constants/area';
import { ConsoleLogger } from '../../../../core/utilities/console-logger';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-saftey', 
    templateUrl: './safety.component.html',
    styleUrls: ['./safety.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SafteyComponent implements OnInit {

    checklistCount = 0;
    isSafteyChecklistExpiredRunning = false; 
    
    constructor(
        private http: HttpClient,
        private toastrService: ToastrService
    ) {}

    ngOnInit() {     
    }

    safetyChecklistCheckExpiredDocs() {
        this.isSafteyChecklistExpiredRunning = true; 
        this.http
            .get<any>(
                `${environment.dotNetApiUrl}/${Area.transportation}/tasks/SafetyCheckForExpired`,
                {}
            )
            .subscribe(
                (x) => {
                    ConsoleLogger.logInfo(x);
                    this.checklistCount = x.length;
                    this.toastrService.success(
                        'Checking safety checklists for expired documents ran successfully.'
                    );
                    this.isSafteyChecklistExpiredRunning = false; 
                },
                (err) => {
                    console.error('Error:', err);
                    this.toastrService.error(
                        'Checking safety checklists for expired documents failed to run.'
                    );
                    this.isSafteyChecklistExpiredRunning = false; 
                }
            );
    }

    safetyChecklistCheckAboutToExpiredDocs() {
        this.isSafteyChecklistExpiredRunning = true; 
		this.http
			.get<any>(
				`${environment.dotNetApiUrl}/${Area.transportation}/tasks/SafetyCheckForAboutToExpired`,
				{}
			)
			.subscribe(
				(x) => {
					ConsoleLogger.logInfo(x);
					this.checklistCount = x.length;
					this.toastrService.success(
						'Checking safety checklists for expired documents ran successfully.'
					);
                    this.isSafteyChecklistExpiredRunning = false; 
				},
				(err) => {
					console.error('Error:', err);
					this.toastrService.error(
						'Checking safety checklists for expired documents failed to run.'
					);
                    this.isSafteyChecklistExpiredRunning = false; 
				}
			);
	}

}


// WEBPACK FOOTER //
// ./src/app/developer/components/developer-tools/safety/safety.component.ts